import Breadcrumb from "../components/Breadcrumb";
import ClientsDetailLayer from "../components/ClientsDetailLayer";

const ClientsDetailPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Clients Details" />

      {/*clients roles page*/}
      <ClientsDetailLayer />
    </>
  );
};

export default ClientsDetailPage;
